module.exports = __webpack_public_path__ + "static/media/pricing-icon-importer.29a9f4fd.svg";